import './SupportScreenShareStart.scss';
import { useState } from 'react';
import { MdScreenShare } from 'react-icons/md';
import Button from '@srm/ui/button';
import Input from '@srm/ui/input';

/** Предел номера обращения в `StartWith` (IMPLEMENTATION.md §16). */
const TICKET_REF_MAX_LENGTH = 64;

export interface ISupportScreenShareStartProps {
    /** Экран уже показывается: второй показ не начать */
    sharing: boolean;
    /**
     * Начать показ. Вызывается прямо в нажатии — выбор вкладки требует жеста пользователя.
     * `ticketRef` — номер обращения без пробелов по краям или `undefined`.
     */
    onStart: (ticketRef: string | undefined) => void;
}

/**
 * Блок окна «Техническая поддержка»: показать экран сотруднику, по желанию — с номером обращения, чтобы показ
 * попал в сеанс этого обращения.
 */
const SupportScreenShareStart = ({ sharing, onStart }: ISupportScreenShareStartProps) => {
    const [ticketRef, setTicketRef] = useState('');

    return (
        <section className="rf-support-share" aria-labelledby="rf-support-share-title" data-testid="support-share">
            <div className="rf-support-share__head">
                <span className="rf-support-share__icon" aria-hidden>
                    <MdScreenShare size={18} />
                </span>
                <div className="rf-support-share__intro">
                    <h3 id="rf-support-share-title" className="rf-support-share__title">
                        Показ экрана
                    </h3>
                    <p className="rf-support-share__hint">
                        {sharing
                            ? 'Экран уже показывается — остановить показ можно в полосе над страницей.'
                            : 'Поддержка увидит только эту вкладку. Управление — только с вашего разрешения.'}
                    </p>
                    {!sharing && (
                        <>
                            <p className="rf-support-share__stop">
                                Завершить показ — «Остановить показ» над страницей. Вернуть себе управление — Esc.
                            </p>
                            <details className="rf-support-share__details">
                                <summary>Что сохраняется и передаётся</summary>
                                <ul>
                                    <li>
                                        Видео не записывается. Сотрудник может сохранять снимки — они доступны в «Доступ
                                        поддержки».
                                    </li>
                                    <li>
                                        Во время показа сотрудник видит ошибки страницы и запросов без значений полей.
                                    </li>
                                    <li>Полный пакет технических данных передаётся только с вашего согласия.</li>
                                </ul>
                            </details>
                        </>
                    )}
                </div>
            </div>
            <div className="rf-support-share__form">
                <Input
                    className="rf-support-share__ticket"
                    label={
                        <span className="rf-support-share__label">
                            Номер обращения <span className="rf-support-share__optional">Необязательно</span>
                        </span>
                    }
                    placeholder="Например, SD-1234"
                    maxLength={TICKET_REF_MAX_LENGTH}
                    value={ticketRef}
                    disabled={sharing}
                    onValueChange={(value: string) => setTicketRef(value)}
                    testid="support-share-ticket"
                />
                <Button
                    className="rf-support-share__start"
                    size="sm"
                    wrap
                    disabled={sharing}
                    startAdornment={<MdScreenShare size={16} />}
                    onClick={() => onStart(ticketRef.trim() || undefined)}
                >
                    Показать экран сотруднику
                </Button>
            </div>
        </section>
    );
};

export default SupportScreenShareStart;
